import { appConfig } from '@/config/app.config';

const lambdaPrefix = appConfig.api.lambdaPrefix;
export const ENDPOINT_ADMIN = {
  // AUTH
  verifyGoogleToken: '/admin/auth/verify-google-token',
  googleLogin: '/admin/auth/google/login',
  googleRefresh: '/admin/auth/google/refresh',
  googleLogout: '/admin/auth/google/logout',
  adminDetails: '/admin/auth',

  // IMAGE UPLOADING URL
  awsUploadKeyURL: '/admin/common/get-s3-upload-url',
  // APK Management
  apkVersions: '/admin/common/apk/versions',
  apkUploadUrl: '/admin/common/apk/upload-url',
  apkValidateVersion: '/admin/common/apk/validate-version',
  apkRegister: '/admin/common/apk/register',
  apkActivateVersion: '/admin/common/apk/activate-version',
  apkUpsert: '/admin/common/apk/upsert',
  clientVersion: '/info/admin/client-version',

  productList: '/admin/product/list',
  productListByType: '/admin/product/list/by-type', // TODO: confirm list-by-type endpoint
  productDetails: '/admin/product/detail',
  productTokenProducts: '/admin/product/token-products',
  productCreate: '/admin/product/create',
  productUpdate: '/admin/product/update',
  comboCreate: '/admin/product/create-combo', // TODO: confirm combo create endpoint

  dealsList: '/admin/deals/list',
  dealsDetail: '/admin/deals/detail',
  dealsCreate: '/admin/deals/create',
  dealsUpdate: '/admin/deals/update',

  merchandiseList: `${lambdaPrefix}/v1/fantasy/admin/merchandise/list`,
  merchandiseCreate: `${lambdaPrefix}/v1/fantasy/admin/merchandise/create`,
  merchandiseUpdate: `${lambdaPrefix}/v1/fantasy/admin/merchandise/update`,

  promoterList: `${lambdaPrefix}/v1/fantasy/admin/promoter/list`,
  promoterCreate: `${lambdaPrefix}/v1/fantasy/admin/promoter/create`,
  promoterUpdate: `${lambdaPrefix}/v1/fantasy/admin/promoter/update`,

  leaderboardList: `${lambdaPrefix}/v1/fantasy/admin/leaderboard/list`,
  leaderboardDetail: `${lambdaPrefix}/v1/fantasy/admin/leaderboard/details`,
  leaderboardCreate: `${lambdaPrefix}/v1/fantasy/admin/leaderboard/create`,
  leaderboardUpdate: `${lambdaPrefix}/v1/fantasy/admin/leaderboard/update`,
  leaderboardTourList: `${lambdaPrefix}/v1/fantasy/admin/leaderboard/user-rank`,
  leaderboardRankSync: `${lambdaPrefix}/v1/fantasy/batch/populate-user-metrics`,
  leaderboardSettleRewards: `${lambdaPrefix}/v1/fantasy/admin/leaderboard/settle-rewards`,

  // Order
  externalProductDetails: '/v1/order/api/products',
  orderTracking: '/v1/order/api/order-sync/tracking',
  orderSyncFailedOrders: '/v1/order/api/order-sync/failed-orders',
  orderSyncSyncOrder: (orderId: string) =>
    `/v1/order/api/order-sync/sync/${orderId}`,
  productSyncEasyEcom: '/admin/product/sync-easy-ecom',
  productOnboardSingle: '/v1/order/api/products/onboarding/single',
  productOnboardBatch: '/v1/order/api/products/onboarding/batch',
  inventoryUpdate: '/v1/order/api/inventory/update',
  inventoryBulkUpdate: '/v1/order/api/inventory/bulk-update',
  productDimensionsUpload: '/v1/order/api/product-dimensions/upload',
  productSellersUnique: '/v1/order/api/products/sellers/unique',

  // Product Search
  productSearch: '/v1/order/api/products/search',

  // Company
  companiesList: '/v1/order/api/companies',
  companiesCreate: '/v1/order/api/companies/create',
  companiesDetail: '/v1/order/api/companies',
  // Category
  categoryList: '/admin/category/list',
  categoryDetails: '/admin/category/detail',
  categoryCreate: '/admin/category/create',
  categoryUpdate: '/admin/category/update',
  // Brand
  brandList: '/admin/brand/list',
  brandDetails: '/admin/brand/detail',
  brandCreate: '/admin/brand/create',
  brandUpdate: '/admin/brand/update',

  // admin apis
  userInfo: '/user/admin/details',
  blockUser: '/user/block',

  // Fantasy /lambda/v1/fantasy : staging
  tournamentList: `${lambdaPrefix}/v1/fantasy/admin/tournament/list`,
  createContestGroup: `${lambdaPrefix}/v1/fantasy/admin/contest/group/create`,
  contestGroupList: `${lambdaPrefix}/v1/fantasy/admin/contest/group/list`,
  updateContestGroupPriority: `${lambdaPrefix}/v1/fantasy/admin/contest/group/update`,
  createContestTemplated: `${lambdaPrefix}/v1/fantasy/admin/contest/template/create`,
  contestTemplateList: `${lambdaPrefix}/v1/fantasy/admin/contest/template/list`,
  fixtureListByTournament: `${lambdaPrefix}/v1/fantasy/admin/fixture/list`,
  delayAtFixture: `${lambdaPrefix}/v1/fantasy/admin/fixture/delay`,
  publishFixtures: `${lambdaPrefix}/v1/fantasy/admin/fixture/publish`,
  goLiveFixtures: `${lambdaPrefix}/v1/fantasy/admin/fixture/make-live`,
  fixtureLineupListings: `${lambdaPrefix}/v1/fantasy/admin/fixture/lineup`,
  updateTournament: `${lambdaPrefix}/v1/fantasy/admin/tournament/update`,
  syncTournamentFromVendor: `${lambdaPrefix}/v1/fantasy/admin/tournament/sync-from-vendor`,
  syncTournamentMatches: `${lambdaPrefix}/v1/fantasy/admin/tournament/sync-matches`,
  syncTourFixturesEntity: `${lambdaPrefix}/v1/fantasy/admin/fixture/sync-entity`,
  updatePlayerLineUp: `${lambdaPrefix}/v1/fantasy/admin/fixture/lineup/update`,
  fixtureContestLists: `${lambdaPrefix}/v1/fantasy/admin/contest/list/by-fixture`,
  addContestTemplatesToFixture: `${lambdaPrefix}/v1/fantasy/admin/contest/template/assign/to-fixture`,
  getContestTemplatesByFixture: `${lambdaPrefix}/v1/fantasy/admin/contest/template/list/by-fixture`,
  updateContestTemplate: `${lambdaPrefix}/v1/fantasy/admin/contest/template/update`,
  updateContestGroup: `${lambdaPrefix}/v1/fantasy/admin/contest/group/update`,
  cancelFixture: `${lambdaPrefix}/v1/fantasy/admin/fixture/cancel`,
  updateContestAutoRecurring: `${lambdaPrefix}/v1/fantasy/admin/contest/auto-recurring/update`,
  pinFixture: `${lambdaPrefix}/v1/fantasy/admin/fixture/pinned`,
  cancelContest: `${lambdaPrefix}/v1/fantasy/admin/contest/cancel`,
  contestDetails: `${lambdaPrefix}/v1/fantasy/admin/contest/detail`,
  playerStats: `${lambdaPrefix}/v1/fantasy/admin/player/stats`,
  updatePlayerPoints: `${lambdaPrefix}/v1/fantasy/admin/fixture/player/points/update`,
  updatePlayerPointsMeta: `${lambdaPrefix}/v1/fantasy/admin/fixture/player/meta/update`,
  updateFixtureStatus: `${lambdaPrefix}/v1/fantasy/admin/fixture/status/update`,
  contestTeamsList: `${lambdaPrefix}/v1/fantasy/admin/contest/team/list`,
  userTeamPlayersList: `${lambdaPrefix}/v1/fantasy/admin/contest/team/player/list`,
  userContestDetails: `${lambdaPrefix}/v1/fantasy/admin/contestDetails`,
  totalTeams: `${lambdaPrefix}/v1/fantasy/admin/team/list`,
  updateTeamDetails: `${lambdaPrefix}/v1/fantasy/admin/team/update`,
  totalPlayerList: `${lambdaPrefix}/v1/fantasy/admin/player/list`,
  playerUpdate: `${lambdaPrefix}/v1/fantasy/admin/player/update`,
  announcePlayer: `${lambdaPrefix}/v1/fantasy/admin/fixture/lineup/announcement`,
  getFixtureRewardState: `${lambdaPrefix}/v1/fantasy/admin/fixture/reward-state`,
  getFixturePlayersFantasyPoints: `${lambdaPrefix}/v1/fantasy/admin/fixture/players/fantasy-point`,
  fixturePlayersFantasyScorecard: `${lambdaPrefix}/v1/fantasy/admin/fixture/players/fantasy-scorecard`,
  fixturePlayersFantasyScorecardFootball: `${lambdaPrefix}/v1/fantasy/admin/fixture/players/fantasy-scorecard-football`,
  batchRewardDistribution: `${lambdaPrefix}/v1/fantasy/batch/orchestrate-reward-distribution`,
  addPlayersToFixture: `${lambdaPrefix}/v1/fantasy/player/add-to-fixture`,
  syncFromVendor: `${lambdaPrefix}/v1/fantasy/admin/fixture/sync-from-vendor`,
  syncFromVendorV2: `${lambdaPrefix}/v1/fantasy/admin/fixture/sync-from-vendor-v2`,
  verifyPlayerDeletion: `${lambdaPrefix}/v1/fantasy/admin/player/verify-deletion`,
  deletePlayer: `${lambdaPrefix}/v1/fantasy/admin/player/delete`,
  bannerCreate: `${lambdaPrefix}/v1/fantasy/admin/banner/create`,
  bannerList: `${lambdaPrefix}/v1/fantasy/admin/banner/list`,
  bannerUpdate: `${lambdaPrefix}/v1/fantasy/admin/banner/update`,
  bannerReorder: `${lambdaPrefix}/v1/fantasy/admin/banner/reorder`,
  getFixtureDetail: `${lambdaPrefix}/v1/fantasy/admin/fixture/detail`,
  stopLiveFeed: `${lambdaPrefix}/v1/fantasy/admin/fixture/stop-live-feed`,
  cancelUnpublishedFixture: `${lambdaPrefix}/v1/fantasy/admin/fixture/cancel-unpublished`,
  fixtureFantasyInfo: `${lambdaPrefix}/v1/fantasy/admin/fixture/fantasy-info`,
  fantasyCdnFixtureList: '/v1/fantasy/cdn/fixture/list',
  riskCheckIncidents: `/risk-check/admin/incidents/search`,
  riskCheckBulkUpdateV2: `/risk-check/admin/incidents/bulk-update/v2`,
  riskCheckStats: `/risk-check/admin/incidents/stats`,
  liteResponseMode: '/Admin/Common/lite-response-mode',
  liteResponseModeToggle: '/Admin/Common/lite-response-mode/toggle',
  entityTournamentList: '/v1/fantasy/admin/entity/tournament/list',
  entityTournamentMatchList: '/v1/fantasy/admin/entity/tournament/match/list',
  entityMatchDetails: '/v1/fantasy/admin/entity/match/detail',

  // Promoters-Tooling
  promoterRequestList: '/admin/promoter/request/list',
  promoterRequestDetail: '/admin/promoter/request/detail',
  promoterRequestApprove: '/admin/promoter/request/approve',
  promoterRequestReject: '/admin/promoter/request/reject',
  promoterVerificationList: '/admin/promoter/verification/list',
  promoterVerificationDetail: '/admin/promoter/verification/detail',
  promoterVerificationApprove: '/admin/promoter/verification/approve',
  promoterVerificationReject: '/admin/promoter/verification/reject',
  promoterDetail: '/admin/promoter/detail',
  promoterDetails: '/admin/promoter/details',
  promoterProfileUpdate: '/admin/promoter/profile/update',
  promoterProfileTransactions: '/admin/promoter',
  promoterWithdrawalList: '/admin/promoter/withdrawal/list',
  promoterWithdrawalDetail: '/admin/promoter/withdrawal/detail',
  promoterWithdrawalUpdate: '/admin/promoter/withdrawal/update',
  promoterWithdrawalDownload: '/admin/promoter/withdrawal/download',
  promoterPendingCounts: '/admin/promoter/pending-counts',
  promoterKycUpload: '/promoter/kyc/upload',
  promoterDocumentPreview: '/admin/promoter/document/preview',
  promoterReferralCodeUpdate: '/admin/promoter/referral-code/update',

  // Support Tooling
  userDetailedInfo: 'admin/user/detailed-info',
  transactionHistory: 'admin/user/transaction-history',
  addGoodwill: '/wallet/add-goodwill',
  orderHistory: 'admin/user/orders',
  gameplayHistory: '/admin/user/gameplay-history',
  userOtpReset: 'admin/user/otp-limits/reset',
  supportBlockUser: '/admin/user-block/block',
  supportUnblockUser: '/admin/user-block/unblock',
  supportBlockStatus: '/admin/user-block/block-status',
  retentionTopupCallingComm: '/clevertap/event/retention-topup-calling-comm',
  addOrUpdateBankDetails: '/v1/identity/bank/v2',
  bankPrimarySwitch: '/v1/identity/bank/primary',
  bankUnlink: '/v1/identity/bank/unlink/v2',
  panVerify: '/v1/identity/kyc/v2',
  nameMatchVerify: '/v1/identity/name/v2',
  panUnlink: '/v1/identity/kyc/unlink/v2',
  fetchUserNames: '/v1/identity/user/detail-v2',
  getUserAviatorDetails: 'v1/aviator/admin/aviator/txn-history',
  getEscalateTicketList: 'admin/escalations/list',
  updateEscalateTicket: 'admin/escalations/update',
  createEscalateTicket: 'admin/escalations/create',

  // Banner Management
  bannerManagementList: `/admin/banner-management/list`,
  bannerManagementAction: `/admin/banner-management/action`,
  bannerManagementDetail: `/admin/banner-management`,
  homeManagementTourDetail: '/v1/fantasy/admin/home-management/tour/detail',
  homeManagementTourTeamConfig:
    '/v1/fantasy/admin/home-management/tour/team-config',
  homeManagementTourTeamConfigSave:
    '/v1/fantasy/admin/home-management/tour/team-config/save',
  homeManagementFixtureBannerConfig:
    '/v1/fantasy/admin/home-management/fixture/banner-config',
  homeManagementFixtureBannerConfigSave:
    '/v1/fantasy/admin/home-management/fixture/banner-config/save',
  homeManagementFixtureBannerActiveToggle:
    '/v1/fantasy/admin/home-management/fixture/banner-active/toggle',
  homeManagementTourBannerActiveToggle:
    '/v1/fantasy/admin/home-management/tour/banner-active/toggle',

  // System Controls - Maintenance & Master Control
  maintenanceSettings: '/admin/system-controls/maintenance/settings',
  maintenanceHistory: '/admin/system-controls/maintenance/history',
  transferPermissions:
    '/admin/system-controls/master-control/transfer-permissions',
  conversionBonus: '/admin/system-controls/master-control/conversion-bonus',
  conversionBonusHistory:
    '/admin/system-controls/master-control/conversion-bonus/history',
  minimumTopup: '/admin/system-controls/master-control/minimum-topup',
  minimumTopupHistory:
    '/admin/system-controls/master-control/minimum-topup/history',
  //Help Center
  helpCenterGetUrl: '/admin/help-center/get-url',
  helpCenterSaveUrl: '/admin/help-center/save-url',
  getS3UploadUrl: '/admin/common/get-s3-upload-url',

  // Horizon (Opinion Trading) Admin
  horizonCategories: '/admin/categories',
  horizonTopics: '/admin/topics',
  horizonEvents: '/admin/events',
  horizonEventTemplates: '/admin/event-templates',
  horizonEventTemplateCategories: '/admin/event-templates/categories',
  horizonEventTemplateConfig: (id: string) =>
    `/admin/event-templates/${id}/config`,
  horizonEventTemplateRequests: '/admin/event-templates/requests',
  horizonUploadS3: '/admin/uploads/s3',

  // Admin Logs & Approvals
  adminLogs: '/admin/logs',
  adminApprovalsAll: '/admin/approvals/all',
  adminApprovals: '/admin/approvals',
};

export const ENDPOINT_NOVO = {
  syncIdentity: '/auth/sync-identity',
  sellRetry: '/sell/retry',
  orderStatus: '/order/status',
};
